import React, { useEffect } from "react";
import errorImg from "../assets/images/education.jpeg";
import { useLoader } from "../context/LoaderContext";

const ErrorPage = () => {
  const { setLoading } = useLoader();

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, [setLoading]);
  return (
    <>
      <section className="page-header" style={{ marginTop: "71px" }}>
        <div
          className="page-header-bg"
          style={{
            backgroundImage: `url(${errorImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>
        <div className="container">
          <div className="page-header__inner">
            <h2>404 Error</h2>
            <ul className="thm-breadcrumb list-unstyled">
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <span>/</span>
              </li>
              <li className="active">404 Error</li>
            </ul>
          </div>
        </div>
      </section>
      <section className="error-page">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="error-page__inner">
                <h2 className="error-page__title">404</h2>
                <h3 className="error-page__tagline">
                  Sorry we can't find that page!
                </h3>
                <p className="error-page__text">
                  The page you are looking for was never existed.
                </p>
                <a
                  href="/"
                  className="thm-btn error-page__btn"
                  style={{ marginTop: "12px" }}
                >
                  back to home
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ErrorPage;
